import api from '@/api/api';
import { toast } from "@/components/utils/ui_v4/alerts/toast/toast";
import { computed, ref, watch } from 'vue';

export default function useProrrogarVigenciaDialog(props) {
  const newDeadlineDate = ref('');
  const newDeadlineTime = ref('');

  const dialogVisible = computed({
    get: () => props.visible,
    set: (value) => {
      if (!value) {
        props.handleClose();
      }
    }
  });

  // Converter data brasileira para ISO
  const formatDateToISO = (brDate) => {
    if (!brDate || brDate.length !== 10) return null;
    const [day, month, year] = brDate.split('/');
    return `${year}-${month}-${day}`;
  };

  // Inicializar campos quando o dialog abre
  watch(() => props.visible, (newVal) => {
    if (newVal) {
      let dateToUse = null;

      if (props.currentDeadline) {
        // Tenta fazer o parse da data atual
        const str = String(props.currentDeadline).trim();

        // Se for BR
        if (/^\d{2}\/\d{2}\/\d{4}/.test(str)) {
          newDeadlineDate.value = str.split(' ')[0];
          const timeMatch = str.match(/(\d{2}):(\d{2})/);
          newDeadlineTime.value = timeMatch ? `${timeMatch[1]}:${timeMatch[2]}` : '23:59';
          return;
        }

        // Se for ISO ou outro formato passível de Date()
        const parsed = new Date(str.replace(' ', 'T')); // Fix para Safari/alguns browsers com espaço
        if (!isNaN(parsed.getTime())) {
          dateToUse = parsed;
          const hours = String(parsed.getHours()).padStart(2, '0');
          const minutes = String(parsed.getMinutes()).padStart(2, '0');
          newDeadlineTime.value = `${hours}:${minutes}`;
        }
      }

      // Se conseguiu parsear a data atual, formata ela para o input
      if (dateToUse) {
        const day = String(dateToUse.getDate()).padStart(2, '0');
        const month = String(dateToUse.getMonth() + 1).padStart(2, '0');
        const year = dateToUse.getFullYear();
        newDeadlineDate.value = `${day}/${month}/${year}`;
      } else {
        // Fallback: amanhã às 23:59
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const day = String(tomorrow.getDate()).padStart(2, '0');
        const month = String(tomorrow.getMonth() + 1).padStart(2, '0');
        const year = tomorrow.getFullYear();

        newDeadlineDate.value = `${day}/${month}/${year}`;
        newDeadlineTime.value = '23:59';
      }
    }
  });

  const handleSave = async () => {
    if (!props.idCotacao || !newDeadlineDate.value || !newDeadlineTime.value) {
      toast.error('EDados incompletos para prorrogar vigência!')
      
      return;
    }

    // Converter data brasileira para ISO
    const isoDate = formatDateToISO(newDeadlineDate.value);
    if (!isoDate) {
      toast.error(`Data inválida: ${newDeadlineDate.value}`);
      
      return;
    }

    try {
      // Formatar data e hora no formato esperado: "YYYY-MM-DD HH:MM:SS"
      const formattedDateTime = `${isoDate} ${newDeadlineTime.value}:00`;

      const { data } = await api.put(
        `/cotacao/atualizar_termino_periodo_recebimento_proposta/${props.idCotacao}`,
        {
          termino_periodo_recebimento_proposta: formattedDateTime
        }
      );

      if (data.success) {
        // Chamar callback de sucesso
        if (props.onSuccess) {
          await props.onSuccess();
        }
        toast.success('Vigência prorrogada com sucesso!');
        // Fechar o modal
        props.handleClose();
      } else {
        // Usar mensagem do backend se disponível, senão usar mensagem padrão
        const errorMessage = data.message || 'Confira a data e hora e tente novamente.';
        const errorTitle = data.error || 'Erro ao prorrogar vigência!';
        toast.error(errorTitle, errorMessage);
        
      }

    } catch (error) {
      // Extrair mensagem do erro do backend se disponível
      let errorMessage = 'Confira a data e hora e tente novamente.';
      let errorTitle = 'Erro ao prorrogar vigência!';

      if (error.response && error.response.data) {
        errorTitle = error.response.data.error || errorTitle;
        errorMessage = error.response.data.message || errorMessage;
      }

      toast.error(errorTitle, errorMessage);
      
    }
  };

  return {
    newDeadlineDate,
    newDeadlineTime,
    dialogVisible,
    handleSave
  };
}
